import React from 'react';
import { Crumb as StrapiCrumb } from '@strapi/design-system';
import CrumbLink from './CrumbLink';
import CurrentCrumb from './CurrentCrumb';

const Crumb = ({ handler, label, isCurrent }) => (
  <StrapiCrumb>
    {isCurrent ? (
      <CurrentCrumb label={label} />
    ) : (
      <CrumbLink handler={handler} label={label} />
    )}
  </StrapiCrumb>
);

export default Crumb;
